// /src/components/common/utils/helpers.js
import store from '@/store/store'
import _has from 'lodash/has'
import _create from 'lodash/create'
import _map from 'lodash/map'

/**
 * Drill down into an object to get value
 * @param {object} obj - Object you desire to be searched
 * @param {array} searchArray - array of properties you want to use cycle down for desired value
 * @return {value} returns property value from object
 */
export const deepSearch = function(obj, searchArray) {
  let searchItem = _create({}, obj)
  let i = 0
  do {
    // lookup should come first
    if (searchArray[i] == 'lookup') {
      i++
      // lookup is used to search for items in a different object
      // lookup should be separated by @ starting with property value within current searchItem
      // @todo make the splits less complicted and use an object
      const lookUp = searchArray[i].split('@')
      // property value to search with searchItem
      const lookUpProp = lookUp[0]
      if (_has(searchItem, lookUpProp) && searchItem[lookUpProp].length > 0) {
        const filterIDS =
          searchItem[lookUpProp] !== undefined ? searchItem[lookUpProp] : false
        if (filterIDS) {
          const storeModule = lookUp[1]
          const stateProp = lookUp[2]
          searchItem = store.getters[storeModule + '/findItemsByIDArray'](
            stateProp,
            filterIDS,
          )
        }
      }
      // advance to search array that was returned
      i++
    }
    if (searchArray[i] == '*') {
      i++
      if (Array.isArray(searchItem)) {
        searchItem = searchItem
          .map(item => {
            return item[searchArray[i]]
          })
          .join(' ')
      }
    }
    if (typeof searchItem != 'object') break
    searchItem = searchItem[searchArray[i]]
    i++
  } while (i < searchArray.length)

  return typeof searchItem == 'undefined' ? false : searchItem
}

/**
 * @function dynamicSort used by array.sort()
 * @description Created this to handle sort of deeply nested properties within an object.
 * @param {array} propertyArray - array of properties you want to use cycle threw to sort objects by prop
 * pass "-" in front of first array string to reverse search
 * @return {array} returns array sorted based upon property passed into it
 */
export const dynamicSort = function(propertyArray) {
  var sortOrder = 1
  if (propertyArray[0][0] === '-') {
    sortOrder = -1
    propertyArray[0] = propertyArray[0].substr(1)
  }

  return (a, b) => {
    const aValue = deepSearch(a, propertyArray)
    const bValue = deepSearch(b, propertyArray)
    if (sortOrder == -1) {
      return bValue.localeCompare(aValue)
    } else {
      return aValue.localeCompare(bValue)
    }
  }
}

export const checkNested = function(obj, prop, ...rest) {
  if (obj === undefined || obj === false) return false
  if (rest.length == 0 && prop in obj) return true
  return checkNested(obj[prop], ...rest)
}

export const isPromise = function(promise) {
  return !!promise && typeof promise.then === 'function'
}
